/**
 * Employee domain entity.
 * Represents an employee in the system.
 */
export class EmployeeEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public phone!: string;
  public isActive!: boolean;
}
